/* eslint-disable import/prefer-default-export */
export const API_URL = `https://pokemon-app-back.herokuapp.com`;
export const MAX_POKEMON_PAGE = 12;
